import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inducation',
  templateUrl: './inducation.component.html',
  styleUrls: ['./inducation.component.scss']
})
export class InducationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
